/**
 * Maps Materials tab keys to material-sheet / registry report type enums.
 */
export const getMaterialSheetReportType = (reportType: string): string => {
  const key = String(reportType || '').trim();
  switch (key) {
    case 'base-pipe':
    case 'pipe':
      return 'BASE_PIPE_REPORT';
    case 'Flanges':
    case 'flanges':
    case 'flange':
      return 'FLANGE_REPORT';
    case 'forge':
      return 'FORGE_REPORT';
    case 'gas':
      return 'GAS_REPORT';
    case 'wire':
      return 'WIRE_REPORT';
    case 'coating':
      return 'COATING_REPORT';
    case 'nde':
      return 'NDE_REPORT';
    case 'misc':
      return 'MISC_REPORT';
    default:
      return 'BASE_PIPE_REPORT';
  }
};
